<template>
    <div id="main">
        <div class="page page-container">
            <div class="novo-fasecultivo">
                <h1 class="title">
                    {{ $t("fase-cultivo") }}:
                    {{
                        !fasecultivo.idfasecultivo
                            ? $t("novo-fase-cultivo")
                            : fasecultivo.descricao
                    }}
                </h1>

                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t("agro") }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{
                                $t("agro-cadastros")
                            }}</a>
                        </li>
                        <li>
                            <a
                                @click="
                                    $router.push({ name: 'agro-fasecultivo' })
                                "
                                >{{ $t("fase-cultivos") }}</a
                            >
                        </li>
                        <li>
                            <a aria-current="page">{{
                                !fasecultivo.idfasecultivo
                                    ? $t("novo-fase-cultivo")
                                    : fasecultivo.descricao
                            }}</a>
                        </li>
                    </ul>
                </nav>

                <div class="columns">
                    <div class="column is-2">
                        <v-input
                            :id="'codigo'"
                            ref="idfasecultivoerpInput"
                            v-model="fasecultivo.idfasecultivoerp"
                            placeholder="placeholder-preencha"
                            :maxlength="30"
                            title="codigo"
                            uppercase
                        />
                    </div>
                    <div class="column">
                        <v-input
                            ref="descricaoInput"
                            v-model="fasecultivo.descricao"
                            :id="'descricao'"
                            :placeholder="'descricao-do-fase-cultivo-placeholder'"
                            :maxlength="100"
                            :title="'descricao'"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!fasecultivo.descricao"
                            uppercase
                            :disabled="
                                (isUpdate && !permissao.update) ||
                                (!isUpdate && !permissao.create)
                            "
                            :required="true"
                        />
                    </div>
                </div>

                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="$router.push({ name: 'agro-fasecultivo' })"
                    >
                        {{ $t("voltar") }}
                    </button>
                    <button
                        v-if="
                            ((isUpdate && permissao.update) ||
                                (!isUpdate && permissao.create)) &&
                            !fasecultivoIntegracao
                        "
                        class="save-btn"
                        type="button"
                        @click="saveFaseCultivo()"
                        :disabled="isSaving"
                    >
                        {{ $t("salvar") }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FaseCultivoService from "@/services/agro/FaseCultivoService";
import FaseCultivoValidation from "@/services/validations/FaseCultivoValidation";

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada. 
 * Usar FaseFenologicaManage ao inves.
 */

export default {
    data() {
        return {
            fasecultivoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("FASECULTIVO"),
            service: new FaseCultivoService(this.$http, this.$router),
            validation: new FaseCultivoValidation(this.$root.msgs),
            isSaving: false,
            fasecultivo: {
                idfasecultivoerp: null,
                descricao: null,
            },
            title: "",
            msgs: [],
            isUpdate: false,
        };
    },
    created() {

        console.warn('FaseCultivoManage sera depreciada. Utilize FaseFenologicaManage ao inves.');

        if (this.$route.params.id) {
            this.isUpdate = true;
        }
        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-cadastros",
            "agro-fasecultivo"
        );
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "fase-cultivos" },
            });
        } else {
            if (this.$route.params.id && this.$route.params.id != "new") {
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        carregarDados(id) {
            this.service.find(id).then((body) => {
                if (body.content) {
                    this.fasecultivo = body.content;
                    this.title = this.fasecultivo.descricao;
                } else {
                    this.$router.push({ name: "agro-fasecultivo-new" });
                }
            });
        },
        saveFaseCultivo(redirect = this.redirectToList) {
            this.fasecultivo = this.mapTosave(this.fasecultivo);
            if (this.validation.validate(this.fasecultivo, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(this.fasecultivo)
                    .then((body) => {
                        let msg = "msg-fasecultivo-salva";

                        if (this.fasecultivo.id) {
                            msg = "msg-fasecultivo-edita";
                        }

                        this.fasecultivo = body.content;
                        this.$root.showMessage("success", msg);

                        redirect(2);
                    })
                    .catch((e) => {
                        if (e.body.message) {
                            this.$root.showMessage("error", e.body.message);
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao"
                            );
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: "agro-fasecultivo",
                });
            }, time * 1000 + 50);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    margin-bottom: 40px;

    .novo-fasecultivo {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;

        > h1 {
            padding-top: 20px;
            margin-bottom: 40px;
        }
    }
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}
</style>